import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../public/fonts/Ivy-Presto-font-Family/fonnts.com-Ivy-Presto-Headline-Thin.otf%22,%22weight%22:%22100%22,%22style%22:%22normal%22},{%22path%22:%22../../public/fonts/Ivy-Presto-font-Family/fonnts.com-Ivy-Presto-Headline-Light.otf%22,%22weight%22:%22300%22,%22style%22:%22normal%22},{%22path%22:%22../../public/fonts/Ivy-Presto-font-Family/fonnts.com-Ivy-Presto-Headline-.otf%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22../../public/fonts/Ivy-Presto-font-Family/fonnts.com-Ivy-Presto-Headline-Semi-Bold.otf%22,%22weight%22:%22600%22,%22style%22:%22normal%22}],%22variable%22:%22--font-ivy-presto-headline%22}],%22variableName%22:%22ivyPrestoHeadline%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'ivyPrestoHeadline', 'ivyPrestoHeadline Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
